<template>
<div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--sm mcc-dialog--info" id="taskDetails-dialog" ref="taskDetailsDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Details</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.taskDetailsDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            <div class="mcc-tabs mcc-tabs--compact mcc-tabs--bar">
                                <input type="radio" id="taskTab" name="task-details-tab-control" checked="">
                                <input type="radio" id="processTab" name="task-details-tab-control">
                                <ul role="tablist" class="mu-mb-05">
                                    <li role="tab">
                                        <label for="taskTab" tabindex="0">
                                            <span>Task</span>
                                        </label>
                                    </li>
                                    <li role="tab">
                                        <label for="processTab" tabindex="0">
                                            <span>Process</span>
                                        </label>
                                    </li>
                                </ul>
                                <div role="tabpanel">
                                    <div class="taskContainer">
                                        <div v-for="(obj, index) in taskDetails" :key="index" class="taskItem">
                                            <div>
                                                <span class="font-weight-bold">{{obj.key}}</span>
                                            </div>
                                            <div>
                                                <span>{{obj.value}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div role="tabpanel">
                                    <div class="processContainer">
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <mcc-alert role="alert" class="mcc-alert mcc-alert--info mcc-alert--compact" color="info">
                                                    <mcc-icon name="info" aria-hidden="true"></mcc-icon>
                                                    <div>
                                                        <span> {{ `Started by ${processObj.startedBy} - ${processObj.createdTime} ` }}</span>
                                                    </div>
                                                </mcc-alert>
                                            </div>
                                        </div>
                                        <div v-for="(obj, index) in processObj.processDetails" :key="index" class="taskItem my-1">
                                            <div>
                                                <span class="font-weight-bold">{{obj.key}}</span>
                                            </div>
                                            <div>
                                                <span>{{obj.value}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--info" @click="$refs.taskDetailsDialog.close()">Ok</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--sm mcc-dialog--info" ref="procDetailsDialog" id="processDetails-dialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Process details</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.procDetailsDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body mu-overflow-hidden">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            <div class="processContainer">
                                <div class="mcc-tabs mcc-tabs--compact mcc-tabs--bar">
                                    <input type="radio" id="processdiagramTab" name="process-tab-control" checked="">
                                    <input type="radio" id="processErrorsTab" name="process-tab-control">
                                    <ul role="tablist" class="mu-mb-05">
                                        <li role="tab">
                                            <label for="processdiagramTab" tabindex="0">
                                                <span>Process diagram</span>
                                            </label>
                                        </li>
                                        <li role="tab">
                                            <label for="processErrorsTab" tabindex="0">
                                                <span>Process errors</span>
                                            </label>
                                        </li>
                                    </ul>
                                    <div role="tabpanel">
                                        <div id="oldSvgContainer" v-html="taskObj.image" name="modelImage" class="modelImageOverflow"></div>
                                    </div>
                                    <div role="tabpanel">
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <div style="position:relative">
                                                   
                                                    <mcc-data-table ref="processErrorsTable" id="processErrorsTableId"></mcc-data-table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--info" @click="$refs.procDetailsDialog.close()">Ok</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--xs mcc-dialog--info" ref="processFailureDetailDialog" id="processFailureDetailDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Process failure details</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeprocessFailureDetailDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div ref="detailedErrorMessage" id="detailedErrorMessage" v-html="errorDetail"></div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--info" @click="closeprocessFailureDetailDialog()">Close</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import Table from "@advanced/component-mosaic-table";
import ProcessErrorAPI from "@/services/ProcessErrorAPI";
import InstanceAPI from "@/services/InstanceAPI";
import Utils from "@/script_utils";

export default {
    props: ['taskId', 'taskObj'],
    data() {
        return {
            taskDetails: [],
            processObj: {
                processDetails: []
            },
            processError: [],
            updateCall: false,
            currentPageSize: 10,
            tableObj: null,
            errorDetail: "",
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
        }
    },
    methods: {
        setViewBoxForSVG() {
            const svgElement = this.$el.querySelector('#oldSvgContainer svg');
             if (svgElement) {
            const bbox = svgElement.getBBox(); 
                svgElement.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`);
            }
        },  
        taskDetailsShowHandler() {
            this.$refs.taskDetailsDialog.show();
            this.initTaskDetails();
            this.initProcessDetails();
        },
        processDetailsShowHandler() {
            this.$refs.procDetailsDialog.show();
            this.initProcessErrorsTable();
            this.updateSVG();
            this.setViewBoxForSVG();
        },
        handleShowErrorDetail() {
            let self = this;
            setTimeout(() => {
                $(self.$refs.detailedErrorMessage).jsonFormatter();
            }, 0);
        },
        initTaskDetails() {
            this.taskDetails = [{
                    'key': 'Name',
                    'value': this.taskObj.taskDetails.name
                },
                {
                    'key': 'Description',
                    'value': this.taskObj.taskDetails.description
                },
                {
                    'key': 'Assignee',
                    'value': this.taskObj.taskDetails.assignee
                },
                {
                    'key': 'Owner',
                    'value': this.taskObj.taskDetails.owner
                },
                {
                    'key': 'Created',
                    'value': this.getFormattedTime(this.taskObj.taskDetails.createTime)
                },
                {
                    'key': 'Due date',
                    'value': this.taskObj.dueDate != '' ? this.taskObj.dueDate : 'No due date'
                },
                {
                    'key': 'Claimed',
                    'value': this.getFormattedTime(this.taskObj.taskDetails.claimTime)
                },
                {
                    'key': 'Completed',
                    'value': this.getFormattedTime(this.taskObj.taskDetails.endTime)
                },
                {
                    'key': 'Duration',
                    'value': this.taskObj.taskDetails.durationInMillis
                },
                {
                    'key': 'Work time',
                    'value': this.taskObj.taskDetails.workTimeInMillis
                }
            ]
        },
        getFormattedTime(timeVal) {
            let formattedTime = ''
            if (timeVal != null && timeVal != "") {
                formattedTime = new Date(timeVal).toLocaleString("en-GB").replace(/\,/g, '');
            }
            return formattedTime;
        },
        initProcessDetails() {
            this.processObj.processDetails = [{
                    'key': 'Name',
                    'value': this.taskObj.processDefinition.name
                },
                {
                    'key': 'Description',
                    'value': this.taskObj.processDefinition.description
                },
                {
                    'key': 'Category',
                    'value': this.taskObj.category
                },
            ];
            this.processObj.startedBy = this.taskObj.processInstance.startUserId != null ? this.taskObj.processInstance.startUserId : 'SYSTEM'
            this.processObj.createdTime = this.getFormattedTime(this.taskObj.processInstance.startTime)
        },
        updateSVG() {
            let self = this;
            Utils.updateSVG("processDetails-dialog");

            InstanceAPI.getActivities(this.taskObj.processInstanceId)
                .then(data => {
                    for (let i in data) {
                        if (data[i].activityType != "exclusiveGateway" &&
                            data[i].activityType != "sequenceFlow") {
                            $("[data-id=" + data[i].activityId + "]").css({
                                stroke: "#009a44"
                            });
                            $("[data-id=" + data[i].activityId + "]").css(
                                "stroke-width", "5px");
                        }
                    }
                    if (self.taskObj.taskDefKey) {
                        $("[data-id=" + self.taskObj.taskDefKey + "]").css({
                            stroke: "#1d428a"
                        });
                        $("[data-id=" + self.taskObj.taskDefKey + "]").css("stroke-width", "5px");
                    }
                });
        },
        updateTemplate() {
            let self = this;
            $(".processName").each((a, obj) => {
                let processName = $(obj)[0].innerText;
                let htmlTag = "";
                if (self.taskObj.isAdminUser) {
                    htmlTag += '<a class="name-link">' + processName + '</a>';
                } else {
                    htmlTag += '<span>' + processName + '<span>';
                }
                $(obj).html(htmlTag);
                $(obj).removeClass("d-none");
            });
            this.$refs.processErrorsTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.$refs.procDetailsDialog.close();
                            self.$router.push(
                                self.CONTEXT_PATH + "/processengine/processes/processinstance/" + self.taskObj.processInstanceId + "/all"
                            );
                        }
                    });
                });
        },
        initProcessErrorsTable() {
            let self = this;
            self.updateCall = false;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const table = document.getElementById("processErrorsTableId");
            self.tableObj = window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No process errors found</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                fixedHeight: true,
                schema: {
                    properties: {
                        processName: {
                            type: "string",
                            title: "Process name",
                            template: '<div class="processName d-none">{{processName}}<div>',
                            sortable: false,
                            columnSearch: false
                        },
                        taskName: {
                            type: "string",
                            title: "Task",
                            sortable: false,
                            columnSearch: false
                        },
                        created: {
                            type: "string",
                            title: "Created",
                            template: '<div class="dateTemplate"><u>{{createdTime}}</u><div>{{createdDateString}}</div></div>',
                            sortable: true,
                            columnSearch: false
                        },
                        actions: {
                            type: "object",
                            title: "Actions",
                            properties: {
                                viewErrorAction: {
                                    type: "string",
                                    format: "button",
                                    title: "View error",
                                    icon: "view",
                                    color: "success",
                                    iconOnly: false
                                }
                            }
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    self.updateCall = false;
                    if (self.tableObj != null) {
                        self.currentPageSize = self.tableObj.tableContext.store.state.pageSize;
                    }
                    let queryString =
                        "start=" +
                        start +
                        "&length=" +
                        limit +
                        "&processInstanceId=" +
                        self.taskObj.processInstanceId;
                    return ProcessErrorAPI.getAllProcessErrors(queryString).then(result => {
                        let responseData = {
                            totalCount: 0,
                            data: []
                        };
                        responseData.totalCount = result.page.totalElements;
                        if (result.data != null) {
                            result.data.forEach(element => {
                                element['createdDateString'] = element['created'] != null ?
                                    Utils.getMomentDateString(element['created']) : '';
                            });

                        }
                        if (result.data != null) {
                            responseData.data = result.data;
                        }
                        self.updateCall = true;
                        return responseData;
                    });
                },
                onAction: (table, action, [{
                    index,
                    rowData,
                    value
                }]) => {
                    if (action == "viewErrorAction") {
                        self.errorDetail = "";
                        self.errorDetail = rowData.errorMessage;
                        self.$refs.procDetailsDialog.close();
                        self.$refs.processFailureDetailDialog.show();
                        self.handleShowErrorDetail();
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                },
                onPageChange: (table, start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        closeprocessFailureDetailDialog(){
            this.errorDetail = "";
            this.$refs.processFailureDetailDialog.close();
        }
    }
}
</script>
<style scoped>
@import "../../../assets/css/symbol.css";
</style>
<style scoped>
.taskItem {
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    padding: 10px !important;
}

.taskItem div[data-v-4fb7266c]:last-child {
    flex-basis: 70%;
    text-align: right;
}

.modelImageOverflow {
    height: 350px;
    overflow: auto;
}
</style>
